package br.gov.go.pge.permanenciaweb.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import br.gov.go.pge.permanenciaweb.shared.MeDto
import br.gov.go.pge.permanenciaweb.shared.PublicConfigDto
import br.gov.go.pge.permanenciaweb.site.IndustrialPalette
import br.gov.go.pge.permanenciaweb.site.components.DefaultButtonVariant
import br.gov.go.pge.permanenciaweb.site.components.PageHeader
import br.gov.go.pge.permanenciaweb.site.components.Panel
import com.varabyte.kobweb.browser.http.bodyAsBytes
import com.varabyte.kobweb.browser.http.http
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.serialization.json.Json
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Main
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/*
 * 403 page: the account exists and can log in, but the roster was not released for it yet.
 *
 * The message tells the user exactly what to ask for (an admin releasing the report), because the
 * alternative — a bare "sem permissão" — leaves leadership accounts stuck with no next step.
 */

private val json = Json { ignoreUnknownKeys = true }

@Page
@Composable
fun SemAcesso() {
    val pageContext = rememberPageContext()
    var me by remember { mutableStateOf<MeDto?>(null) }
    var contact by remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        document.title = "Acesso ao relatório não liberado"
        if (AppGlobals.isExporting) return@LaunchedEffect
        me = runCatching {
            val response = window.http.get("/api/me")
            if (response.ok) json.decodeFromString<MeDto>(response.bodyAsBytes().decodeToString()) else null
        }.getOrNull()
        contact = runCatching {
            val response = window.http.get("/api/public-config")
            if (response.ok) {
                json.decodeFromString<PublicConfigDto>(response.bodyAsBytes().decodeToString()).contactEmail
            } else {
                ""
            }
        }.getOrDefault("")
    }

    Column(
        modifier = Modifier
            .maxWidth(40.cssRem)
            .padding(top = 1.cssRem, right = 1.5.cssRem, bottom = 1.5.cssRem, left = 1.5.cssRem)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .margin(left = autoLength, right = autoLength)
            .gap(0.75.cssRem),
    ) {
        PageHeader(
            title = "Acesso ao relatório não liberado",
            subtitle = null,
            me = me,
            currentPath = "/sem-acesso",
        )

        Panel {
            Column(modifier = Modifier.padding(1.25.cssRem).gap(0.75.cssRem)) {
                H1(attrs = Modifier.fontSize(1.cssRem).fontWeight(FontWeight.SemiBold).margin(0.cssRem).toAttrs()) {
                    Text("Falta um passo")
                }
                P(attrs = Modifier.margin(0.cssRem).toAttrs()) {
                    Text(
                        "Sua conta já pode entrar, mas o painel de permanência ainda não foi liberado. " +
                            "Peça a um administrador para liberar o acesso ao relatório na página de usuários."
                    )
                }
                P(attrs = Modifier.margin(0.cssRem).color(IndustrialPalette.Muted).toAttrs()) {
                    Text(
                        if (contact.isNotEmpty()) "Contato: $contact" else "Contate o administrador do sistema."
                    )
                }
                Column(modifier = Modifier.gap(0.5.cssRem)) {
                    if (me?.canCreateStayPermits == true || me?.canViewStayPermits == true) {
                        Button(
                            onClick = { pageContext.router.navigateTo("/liberacoes") },
                            variant = DefaultButtonVariant,
                            size = ButtonSize.SM,
                        ) {
                            Text("Ir para Liberações")
                        }
                    }
                    Button(
                        onClick = { window.location.href = "/login" },
                        variant = DefaultButtonVariant,
                        size = ButtonSize.SM,
                    ) {
                        Text("Entrar com outra conta")
                    }
                }
            }
        }
    }
}
